import React, { Fragment, FunctionComponent } from 'react';
import { Link } from "react-router-dom";
import { localize } from "src/l10n";

interface IProps {
    notification: Spintr.INotification;
}

const QaCreatedNotification: FunctionComponent<IProps> = (props)  => {
    const notification = props.notification as Spintr.IQaCreatedNotification;
    if (!notification) {
        return;
    }

    return (
        <Fragment>
            <Link to={`/profile/${notification.userId}`}>
                {notification.userName}
            </Link>
            {" " + localize("HarSkapatEnFraga") + "."}
        </Fragment>
    );
};

export default QaCreatedNotification;
